var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToponodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061E37",
    d: "M6,4.84291618 L7.15708382,6 L11.4545455,6 C11.7557917,6 12,6.24420832 12,6.54545455 L12,11.4545455 C12,11.7557917 11.7557917,12 11.4545455,12 L6.54545455,12 C6.24420832,12 6,11.7557917 6,11.4545455 L6,7.15708382 L4.84291618,6 L0.545454545,6 C0.244208318,6 3.68920228e-17,5.75579168 0,5.45454545 L0,0.545454545 C-3.68920228e-17,0.244208318 0.244208318,5.53380342e-17 0.545454545,0 L5.45454545,0 C5.75579168,-5.53380342e-17 6,0.244208318 6,0.545454545 L6,4.84291618 Z M1.63636364,1.63636364 L1.63636364,4.36363636 L4.36363636,4.36363636 L4.36363636,1.63636364 L1.63636364,1.63636364 Z M7.63636364,7.63636364 L7.63636364,10.3636364 L10.3636364,10.3636364 L10.3636364,7.63636364 L7.63636364,7.63636364 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToponodeIcon);
export default __webpack_public_path__ + "static/media/toponode-icon.e129ec4d8511f3f3319c943d5ecfc92f.svg";
export { ForwardRef as ReactComponent };